module.exports = __webpack_public_path__ + "img/tools.1d770349.png";